import React, { Fragment, useMemo } from 'react';
import { SdpHasNickname, SdpResponse, headPointPhysicalMeter } from '../../models/SdpResponse';

import { ReactComponent as ArrowLeftIcon } from '../../assets/arrow-left.svg';
import Skeleton from 'react-loading-skeleton';

export interface SdpHeaderProps {
  sdp?: SdpResponse | null;
  onClickBack?: () => void;
}
export default function SdpHeader({ sdp, onClickBack }: SdpHeaderProps) {
  const hasNickname = useMemo(() => SdpHasNickname(sdp), [sdp]);
  return (
    <div className="detail-header">
      {sdp ? (
        <div className="detail-header__content">
          {onClickBack && (
            <ArrowLeftIcon
              onClick={onClickBack}
              className="detail-header__content__icon"
              width={24}
              height={24}
            />
          )}
          <div className="detail-header__content__text">
            <Fragment>
              <h2>{hasNickname ? sdp?.userHasAccessNickname : sdp?.headpoint.ean}</h2>
              {!hasNickname && <h3>{headPointPhysicalMeter(sdp?.headpoint)?.serialNumber}</h3>}
            </Fragment>

            {hasNickname && (
              <h3>
                {sdp?.headpoint.ean}&nbsp;-&nbsp;{' '}
                {headPointPhysicalMeter(sdp?.headpoint)?.serialNumber}
              </h3>
            )}
          </div>
        </div>
      ) : (
        <Fragment>
          <Skeleton count={1} height={22} width="40%" className="mb-2" />
          <Skeleton count={1} height={16} width="25%" className="mb-4" />
        </Fragment>
      )}
    </div>
  );
}
